import { Injectable } from '@angular/core';
import { ConversationsService } from './conversations/conversations.service';
import { DashboardStore } from './dashboard.store';
import { JobsService } from './main/accountant/jobs-and-tasks/jobs.service';

@Injectable({ providedIn: 'root' })
export class DrawerService {

    constructor(
        private conversationsService: ConversationsService,
        private jobsService: JobsService,
        private dashboardStore: DashboardStore
    ) { }

    async goToTrackedItem(trackedItemUuid: string, companyId: number) {
        const trackedItem = await this.conversationsService.get_tracked_item(
            trackedItemUuid
        );
        const company = await this.dashboardStore.getConversationCompany(companyId);
        this.dashboardStore.selectTrackedItem(
            trackedItem, company);
    }

    async goToJob(jobUuid: string) {
        const job = await this.jobsService.getJob(jobUuid);
        this.dashboardStore.selectJob(job);
    }
}

